var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatSocialX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social icons",
    clipPath: "url(#clip0_12_13077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "X-logo",
    d: "M10.8584 8.56904L17.4161 0.947266H15.8621L10.1681 7.56514L5.62033 0.947266H0.375L7.25214 10.9547L0.375 18.9473H1.92904L7.94205 11.9586L12.7448 18.9473H17.9902L10.858 8.56904H10.8584ZM8.72995 11.0428L8.03315 10.0463L2.48898 2.11698H4.8759L9.35011 8.51621L10.0469 9.51272L15.8628 17.8308H13.4759L8.72995 11.0432V11.0428Z",
    fill: "#DD5800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_13077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.947266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatSocialX);
export default __webpack_public_path__ + "static/media/sat_social_x.4257e2e906c5979650f7f4f627feca4a.svg";
export { ForwardRef as ReactComponent };